import React from 'react';
import { motion } from 'framer-motion';

const DeadlossSection = () => {
  return (
    <motion.section 
      className="py-16 px-6 md:px-12"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      data-testid="deadloss-section"
    >
      <div className="max-w-screen-2xl mx-auto">
        <div className="max-w-2xl">
          <p className="text-sm text-neutral-500 leading-relaxed">
            Coming soon — an exciting new project in association with Deadloss Productions.
          </p>
          <p className="text-sm text-neutral-600 mt-2">
            Venue to be confirmed.
          </p>
        </div>
      </div>
    </motion.section>
  );
};

export default DeadlossSection;
